<template>
  <modal
    class="editCreditLimit"
    name="approvalRequestModal"
    transition="pop-out"
    :width="modalWidth"
    :height="300"
    @opened="opened"
  >
    <div class="retainership__box">
      <div class="text-center">
        <h3 class="add__retainership__header mt-5">
          
          {{ $t("text.retainership.approveRequest") }}
        </h3>

        <div class="w-75 mx-auto">
          <multiselect
            v-model="value"
            :options="options"
            track-by="bankName"
            label="bankName"
            :show-labels="false"
            :placeholder="$t('text.shiftDeposits.selectBank')"
            :searchable="true"
            :allow-empty="false"
            :loading="bankLoading"
          >
            <template slot="singleLabel" slot-scope="{ option }"
              >{{ option.bankName }}
            </template>
          </multiselect>
        </div>

        <div class="add__retainership__form__wrapper">
          <!-- <div class="form_input_section mt-4">
            <div class="input__div" ref="email_input_div">
              <div class="placeholder_div">
                <img
                  src="@/assets/img/email.png"
                  width="50%"
                  class="input_placeholder_icon"
                />
              </div>
              <div class="input_field_section">
                <input
                  type="text"
                  :placeholder="$t('text.editCreditLimit.creditLimit')"
                  v-model="creditLimitValue"
                />
              </div>
            </div>
          </div> -->
          <div ref="email_error_message"></div>
          <div class="text-center mt-5">
            <button
              class="add_quick_fuel_btn"
              @click="editCreditLimit($event)"
              :disabled="isButtonDisabled ? true : null"
              :style="[
                isButtonDisabled
                  ? { cursor: 'not-allowed' }
                  : { cursor: 'pointer' },
              ]"
              style="background-color:#46266e"
            >
              {{ $t("text.categories.submit") }} <span></span>
            </button>
            <img
              src="@/assets/img/git_loader.gif"
              style="display: none"
              width="35px"
              class="ml-3 loader"
            />
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>
  <script>
import configObject from "@/config";
import Multiselect from "vue-multiselect";
import JQuery from "jquery";
let $ = JQuery;

const MODAL_WIDTH = 600;

export default {
  name: "editCreditLimit",
  props: ["creditLimit", "email"],
  components: {
    Multiselect,
  },
  data() {
    return {
      creditLimitValue: null,
      modalWidth: MODAL_WIDTH,
      isButtonDisabled: false,
      value: "",
      options: [
        "Select option",
        "options",
        "selected",
        "multiple",
        "label",
        "searchable",
        "clearOnSelect",
        "hideSelected",
        "maxHeight",
        "allowEmpty",
        "showLabels",
        "onChange",
        "touched",
      ],
    };
  },
  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },
  methods: {
    closeCreditLimit() {
      this.$modal.hide("editCreditLimit");
    },
    editCreditLimit($event) {
      $event.preventDefault();
      if (!this.creditLimitValue) {
        this.$toast.open({
          message: this.$t("text.editCreditLimit.creditLimitMissing"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      let companyID;
      if (localStorage.getItem("companyDetails") !== null) {
        companyID = JSON.parse(localStorage.getItem("companyDetails")).id;
      }
      let data = {
        email: this.email,
        creditLimit: parseFloat(this.creditLimitValue),
      };
      this.isButtonDisabled = true;
      $(".loader").show();
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Company/UpdateCustomerCreditLimit/${companyID}`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          $(".loader").hide();
          this.isButtonDisabled = false;
          data = null;
          this.creditLimitValue = null;
          this.$modal.hide("editCreditLimit");
          this.$toast.open({
            message: this.$t("text.editCreditLimit.successfullyEdited"),
            type: "success",
            duration: 3000,
          });
          this.$eventHub.$emit("getRetainerships");
        })
        .catch((error) => {
          this.$toast.open({
            message: this.$t("text.editCreditLimit.unsuccessfulEdit"),
            type: "error",
            duration: 3000,
          });
          this.isButtonDisabled = false;
          $(".loader").hide();
        });
    },
    opened() {
      this.creditLimitValue = this.creditLimit;
    },
  },
};
</script>
  